export default {
	'main-info': 'Main info',
	'mix-items': 'Mix items',
}